var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLandscape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.606 25.022a7.897 7.897 0 0 1 6.133-1.252c2.138.438 3.983 1.718 5.19 3.587l21.06 32.77a4.34 4.34 0 0 1 .196 4.317c-.713 1.37-2.095 2.223-3.597 2.223H7.408a4.047 4.047 0 0 1-3.591-2.223 4.324 4.324 0 0 1 .201-4.323l13.855-21.44c.06-.09.337-.489.402-.573 2.852-3.655 7.994-4.239 11.498-1.325l3.32 2.74L41.45 27.2a8.325 8.325 0 0 1 2.155-2.178zM20.207 13.333c3.381 0 6.122 2.828 6.122 6.316s-2.74 6.316-6.122 6.316c-3.38 0-6.122-2.828-6.122-6.316s2.741-6.316 6.122-6.316z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLandscape);
export default __webpack_public_path__ + "static/media/icon-landscape.be58d377.svg";
export { ForwardRef as ReactComponent };